import React from 'react'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import  { useDispatch, useSelector } from 'react-redux'
import { Card, Row, Col} from 'react-bootstrap';
import { CompilaQuestionarioKpisValoriEsempio } from "./CompilaQuestionarioKpisValoriEsempio.js";

import { BsPencil } from "react-icons/bs";
import { Button, Modal } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';

import { useState }  from 'react';
import '../s_csvc-css/beta.css'; 
// import { csvcSoggettiListV1 } from '../components-csvc-one/testSoggettiList.js';

import { updateKpi } from '../reduxStore/questCorrenteSlice.js'
import { TextWithLineBreaks } from '../components-csvc/TextWithLineBreaks'

/*
function nomeEsteso(key) {
    const pair = csvcSoggettiListV1.find(pair => pair.id === key);
    return pair ? pair.nome.toUpperCase() : null;
}
*/
function nomeEsteso(key) {
    const questionarioCorrente = useSelector((state) => state.questCorrente);
    // Estraggo Array stakeholders filtrato
    // const excludedIds = ['AZ', 'CT'];
    // const stakeholdersFiltered = questionarioCorrente.stakeholders.filter(stakeholder => !excludedIds.includes(stakeholder.id));
    const pair = questionarioCorrente.stakeholders.find(pair => pair.id === key);
    return pair ? pair.alias.toUpperCase() : null;
}

function estraiParteIntera(input) {
    // Verifica se l'input è di tipo stringa
    if (typeof input === 'string') {

        // Restituisce 0 se la stringa di input è vuota
        if (input.trim() === '') {
            return '0';
        }

        // Sostituisce eventuali virgole con punti
        input = input.replace(',', '.');

        // Prova a convertire l'input in un numero
        const numero = parseFloat(input);

        // Verifica se la conversione è riuscita
        if (!isNaN(numero)) {
            // Restituisce la parte intera del numero come stringa
            return Math.floor(numero).toString();
        }
    }
    // Restituisce zero se l'input non è valido
    return '0';
}


export const CompilaQuestionarioKpisValori = (props) => {

// ----------------------------------------------------------
//  INIZIO GESTIONE PER react-hook-form
    const dispatch = useDispatch();
    const {register, handleSubmit, formState: {errors}} = useForm()

    const onReactHookFormSubmit = (data) => {
        // console.log('onReactHookFormSubmit - questionarioCorrente: ', questionarioCorrente.questionarioUuid)
        // console.log(data)

        const updatedValues = {
            questionarioUuid: questionarioCorrente.questionarioUuid, 
            kpiKey: props.kpiValueKey, 
            descrizione: props.descrizione, 
            stakeholder: props.stakeholder, 
            sottoconto: props.sottoconto, 
            perPrecGiust: data.perPrecGiust, 
            perPrecValore: estraiParteIntera(data.perPrecValore), 
            perCorrGiust: data.perCorrGiust, 
            perCorrValore: estraiParteIntera(data.perCorrValore), 
            perSuccGiust: 'valore finale', 
            perSuccValore: (parseInt(data.perPrecValore,10) + parseInt(data.perCorrValore,10)).toString() 
        }
        // console.log('handleSubmitModal - updatedValues: ', updatedValues)
        dispatch(updateKpi(updatedValues)) 

        setModalShow(false)
    }
//  FINE GESTIONE PER react-hook-form
// ----------------------------------------------------------


// ----------------------------------------------------------
//  INIZIO GESTIONE Modal
  const [modalShow, setModalShow] = useState(false);
  // const [modalValue, setModalValues] = React.useState(rilevanzaValore);

  const handleOpenModalToUpdateValues = () => {
    // setModalValues(rilevanzaValore)
    setModalShow(true)
}
;
/*
  //  const handleChange = (event) => {
  //    //     setModalValues(Number(event.target.value))
  //  };
*/

/*
const handleSubmitModal = (data) => {
    console.log('handleSubmitModal - questionarioCorrente: ', questionarioCorrente.questionarioUuid)
    console.log(data)

  //   // console.log('handleSubmitModal - questionarioCorrente: ', questionarioCorrente.questionarioUuid)
  //   // dispatch(tempSetValoreRilevanza({ambito: rilevanzaAmbito, effetto:rilevanzaEffetto, valore:modalValue}))
  // 
  //   const updatedValues = {questionarioUuid: questionarioCorrente.questionarioUuid, ambito: rilevanzaAmbito, effetto: rilevanzaEffetto, valore: modalValue.toString()}
  //   console.log('handleSubmitModal - updatedValues: ', updatedValues)
  //   dispatch(updateRilevanzaAmbiti(updatedValues)) 
  // 
  setModalShow(false)
}
*/


const handleCloseModal = () => {
    //   // console.log('handleSubmitModal - questionarioCorrente: ', questionarioCorrente.questionarioUuid)
    //   // dispatch(tempSetValoreRilevanza({ambito: rilevanzaAmbito, effetto:rilevanzaEffetto, valore:modalValue}))
    // 
    //   const updatedValues = {questionarioUuid: questionarioCorrente.questionarioUuid, ambito: rilevanzaAmbito, effetto: rilevanzaEffetto, valore: modalValue.toString()}
    //   console.log('handleSubmitModal - updatedValues: ', updatedValues)
    //   dispatch(updateRilevanzaAmbiti(updatedValues)) 
 
    setModalShow(false)
  }
//  FINE GESTIONE Modal
// ----------------------------------------------------------

    // estraggo kpiValue per questo elemento:
    const questionarioCorrente = useSelector((state) => state.questCorrente);
    const result = questionarioCorrente.kpis.find(item => item.kpiKey === props.kpiValueKey);
    const thisKpiValues = (result !== undefined) ? result : { kpiKey: props.kpiValueKey, stakeholder: "", sottoconto: "", descrizione: "", perPrecGiust: "", perPrecValore: 0, perCorrGiust: "", perCorrValore: 0, perSuccGiust: "", perSuccValore: 0 }

    const kpiType  = props.kpiValueKey.substring(20, 22)
    // console.log('kpiType: ', kpiType);

/*
    // BOTTONE PREDISPOSTO CON STATO INTERMEDIO: warning
    <Button variant={(thisKpiValues.perCorrValore===0)?'danger': (thisKpiValues.perPrecValore===0)?'warning':'success'} onClick={handleOpenModalToUpdateValues}>
        <BsPencil />
    </Button>                
*/

    return (
        <>
            <Card id="{props.kpiValueKey}" className="py-3 mb-3">
            <Card.Body className="py-3">
                <Row className="g-0">

                    <Col xs={3} md={3} className='border-200 border-bottom border-end border-md-end-0 pb-0 pb-3 pt-3 ps-3'>
                        <Button variant={(thisKpiValues.perCorrValore===0)?'danger': 'success'} onClick={handleOpenModalToUpdateValues}>
                            <BsPencil />
                        </Button>                
                    </Col>

                    <Col xs={9} md={9} className='border-200 border-bottom border-end border-md-end-0 pb-0 pb-3 pt-3 ps-3'>
                        <h5 className="text-primary mb-0 text-center"><strong>{props.descrizione}</strong></h5>
                        {/*
                            <h7 className="text-primary mb-0 text-center">in box dataEntry: {props.kpiValueKey}</h7><br />
                            <h7 className="text-primary mb-0 text-center">kpiType: {props.kpiValueKey.substring(21, 23)}</h7><br />
                            <h7 className="text-primary mb-0 text-center">stakeholder: {props.stakeholder}</h7><br />
                            <h7 className="text-primary mb-0 text-center">sottoconto: {props.sottoconto}</h7><br />
                            <h7 className="text-primary mb-0 text-center">color: {props.color}</h7><br />
                        */}
                    </Col>
                </Row>

                { props.helpRowsObjectArray.length>0 ? (
                    <Row className="g-0">
                        <Col xs={12} md={12} className='border-200 border-bottom border-end border-md-end-0 pb-0 pb-3 pt-3 ps-3'>
                        <CompilaQuestionarioKpisValoriEsempio helpRowsObjectArray={props.helpRowsObjectArray} />
                        </Col>
                    </Row>
                ):(<></>)}

                { kpiType==='B1' ? (
                    <Row className="g-0">
                    <Col xs={6} md={2} className='border-200 border-bottom border-end pb-2 pt-2 pe-3'>
                        <p className="font-sans-serif lh-1 mb-1 fs-7  text-end align-middle">{questionarioCorrente.perPrec}</p>
                        </Col>
                        <Col xs={6} md={8} className='border-200 border-bottom border-end border-md-end-0 pb-2 pt-2 ps-3'>
                        <p className="font-sans-serif lh-1 mb-1 fs-9 text-body align-middle">{<TextWithLineBreaks text={thisKpiValues.perPrecGiust} />}</p>
                        </Col>
                        <Col xs={6} md={2} className='border-200 border-bottom border-end border-md-end-0 pb-2 pt-2 ps-3'>
                        <p className="font-sans-serif lh-1 mb-1 fs-9 text-body align-middle">{thisKpiValues.perPrecValore}</p>
                        </Col>
                    </Row>
                ):(<></>)}

                <Row className="g-0">
                    <Col xs={6} md={2} className='border-200 border-bottom border-end pb-2 pt-2 pe-3'>
                    <p className="font-sans-serif lh-1 mb-1 fs-7  text-end align-middle">{questionarioCorrente.perCorr}</p>
                    </Col>
                    <Col xs={6} md={8} className='border-200 border-bottom border-end border-md-end-0 pb-2 pt-2 ps-3'>
                    <p className="font-sans-serif lh-1 mb-1 fs-9 text-body align-middle">
                    {<TextWithLineBreaks text={thisKpiValues.perCorrGiust} />}</p>
                    </Col>
                    <Col xs={6} md={2} className='border-200 border-bottom border-end border-md-end-0 pb-2 pt-2 ps-3' style={{ backgroundColor: 'yellow' }}>
                    <p className="font-sans-serif lh-1 mb-1 fs-9 text-body align-middle">{thisKpiValues.perCorrValore}</p>
                    </Col>
                </Row>

                { kpiType==='B1' ? (
                    <Row className="g-0">
                        <Col xs={6} md={2} className='border-200 border-bottom border-end pb-2 pt-2 pe-3'>
                        <p className="font-sans-serif lh-1 mb-1 fs-7  text-end align-middle">{questionarioCorrente.perSucc}</p>
                        </Col>
                        <Col xs={6} md={8} className='border-200 border-bottom border-end border-md-end-0 pb-2 pt-2 ps-3'>
                        <p className="font-sans-serif lh-1 mb-1 fs-9 text-body align-middle">{<TextWithLineBreaks text={thisKpiValues.perSuccGiust} />}</p>
                        </Col>
                        <Col xs={6} md={2} className='border-200 border-bottom border-end border-md-end-0 pb-2 pt-2 ps-3'>
                        <p className="font-sans-serif lh-1 mb-1 fs-9 text-body align-middle">{thisKpiValues.perSuccValore}</p>
                        </Col>
                    </Row>
                ):(<></>)}

            </Card.Body>
            </Card>

            <Modal size="lg" show={modalShow} onHide={handleCloseModal} backdrop="static" keyboard={false}>
                <Modal.Header>
                <Modal.Title>Aggiorna KPI {props.kpiValueKey.substring(0, 7)} - Azione {props.kpiValueKey.substring(15, 16)} - {(props.kpiValueKey.substring(20, 22)) === 'O1'
                        ? 'X2I - OPPORTUNITÀ'
                        : (props.kpiValueKey.substring(20, 22)) === 'B1'
                        ? 'Y2I - OPPORTUNITÀ'
                        : (props.kpiValueKey.substring(20, 22)) === 'B2'
                        ? 'Y3I - COSTI'
                        : (props.kpiValueKey.substring(20, 22)) === 'B3'
                        ? 'Y4I - CONTRIBUTI'
                        : 'tipo non previsto'}<br /><br/>
                        {props.descrizione}<br/><br/>
                        {(props.stakeholder.trim() != '') ? 'Stakeholder: ' + nomeEsteso(props.stakeholder) : ''} 
                        {(props.sottoconto.trim() != '') ? 'Conto: ' + props.sottoconto : ''} 
                        <br />
                        <span style={{color:'red', fontSize:'65%'}}>ATTENZIONE: I valori che indicano un valore negativo devono essere inseriti con il segno meno</span>
                        </Modal.Title>
                <FalconCloseButton onClick={handleCloseModal}/>
                
                </Modal.Header>
                <Modal.Body>
                    { props.helpRowsObjectArray.length>0 ? (
                        <Row className="g-0">
                            <Col xs={12} md={12} className='border-200 border-bottom border-end border-md-end-0 pb-0 pb-3 pt-3 ps-3'>
                            <CompilaQuestionarioKpisValoriEsempio helpRowsObjectArray={props.helpRowsObjectArray} />
                            </Col>
                        </Row>
                    ):(<></>)}
                    <form onSubmit={handleSubmit(onReactHookFormSubmit)}>
                        <input type="hidden" name="descrizione" value= {props.descrizione} />
                        <input type="hidden" name="stakeholder" value= {props.stakeholder} />
                        <input type="hidden" name="sottoconto"  value= {props.sottoconto} />

                        { kpiType==='B1' ? (
                            <Row className="g-0">

                                <Col xs={6} md={2} className='border-200 border-bottom border-end d-flex align-items-center justify-content-end'>
                                <p className="font-sans-serif lh-1 mb-1 fs-7 text-end ">{questionarioCorrente.perPrec}</p>
                                </Col>

                                <Col xs={6} md={8} className='border-200 border-md-200 border-bottom border-md-end pb-3 pt-3 ps-3'>
                                <div className="form-group">
                                    <textarea 
                                        id="perPrecGiust" 
                                        {...register('perPrecGiust')} 
                                        autoComplete="off" 
                                        defaultValue={thisKpiValues.perPrecGiust} 
                                        style={{ height: '150px', width: '100%' }} 
                                    ></textarea><br />
                                    {errors.perPrecGiust && <p>La giustificazione è obbligatoria</p>}
                                </div>
                                </Col>

                                <Col xs={6} md={2} className='border-200 border-bottom border-end border-md-end-0 pb-0 pb-3 pt-3 ps-3'>
                                <div className="form-group">
                                    <input 
                                        id="perPrecValore" 
                                        {...register('perPrecValore')} 
                                        type="number" 
                                        autoComplete="off" 
                                        defaultValue={thisKpiValues.perPrecValore} 
                                        className="no-arrows" 
                                        style={{ width: '100%' }} 
                                    /><br />
                                    {errors.perPrecValore && <p>Valore obbligatorio</p>}
                                </div>
                                </Col>
                            </Row>
                        ):(<>
                            <input type="hidden" name="perPrecGiust"  value= '' />
                            <input type="hidden" name="perPrecValore"  value= '0' />
                        </>)}

                        <Row className="g-0">
                            <Col xs={6} md={2} className='border-200 border-bottom border-end d-flex align-items-center justify-content-end'>
                                <p className="font-sans-serif lh-1 mb-1 fs-7">{questionarioCorrente.perCorr}</p>
                            </Col>

                            <Col xs={6} md={8} className='border-200 border-md-200 border-bottom border-md-end pb-3 pt-3 ps-3'>
                                <textarea 
                                    id="perCorrGiust" 
                                    {...register('perCorrGiust')} 
                                    autoComplete="off" 
                                    defaultValue={thisKpiValues.perCorrGiust} 
                                    style={{ height: '150px', width: '100%' }} 
                                ></textarea><br />
                                {errors.perCorrGiust && <p>La giustificazione è obbligatoria</p>}
                            </Col>


                            <Col xs={6} md={2} className='border-200 border-bottom border-end border-md-end-0 pb-0 pb-3 pt-3 ps-3' >
                                <input 
                                    id="perCorrValore" 
                                    {...register('perCorrValore')} 
                                    type="number" 
                                    autoComplete="off" 
                                    defaultValue={thisKpiValues.perCorrValore} 
                                    className="no-arrows" 
                                    style={{ width: '100%' ,  backgroundColor: 'yellow'}}                                  
                                /><br />
                                {errors.perCorrValore && <p>Valore obbligatorio</p>}
                            </Col>
                        </Row>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    {props.kpiValueKey}&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button variant="secondary" onClick={handleCloseModal}>Annulla</Button>
                    <Button variant="primary" onClick={handleSubmit(onReactHookFormSubmit)}>Invia</Button>
                </Modal.Footer>
            </Modal>
        </>
      );

    };

CompilaQuestionarioKpisValori.propTypes = {
    kpiValueKey: PropTypes.string.isRequired,
    descrizione: PropTypes.string.isRequired,
    stakeholder: PropTypes.string,
    sottoconto: PropTypes.string,
    helpRowsObjectArray: PropTypes.array,
    color: PropTypes.string.isRequired,
};

/*
    <Col xs={6} md={2} className='border-200 border-bottom border-end border-md-end-0 pb-0 pb-3 pt-3 ps-3'>
        <input 
            type="number" 
            id="perCorrValore" 
            {...register('perCorrValore', { required: true })} 
            autoComplete="off" 
            defaultValue={thisKpiValues.perCorrValore} 
            className="no-arrows" 
            style={{ width: '100%' }}                                     
        /><br />
        {errors.perCorrValore && <p>Il valore del periodo corrente è obbligatorio</p>}
    </Col>
*/